export const feedback = {
  title: 'Feedback',
  heading: 'Share your experience',
  description: 'Help us improve Queri by sharing your experience.',
  // Display text per question id in config/feedback-form; the config stays the source of ids and values
  questions: {
    overall_satisfaction: {
      label: 'Overall Satisfaction',
      description: 'How satisfied are you with Queri overall?',
    },
    most_useful_feature: {
      label: 'Most Useful Feature',
      description: 'Which feature do you find most useful?',
    },
    ease_of_use: {
      label: 'Ease of Use',
      description: 'How easy is Queri to use?',
    },
    missing_features: {
      label: 'Missing Features',
      description: 'Are there any features you wish Queri had?',
    },
    additional_comments: {
      label: 'Additional Comments',
      description: 'Any other feedback you would like to share?',
    },
  } as Record<string, { label: string; description: string }>,
  // Display labels for select option values (the English value is what gets submitted)
  options: {
    'Document Chat': 'Document Chat',
    'Document Review': 'Document Review',
    Playbooks: 'Playbooks',
    'Knowledge Database': 'Knowledge Database',
    'Meeting Assistant': 'Meeting Assistant',
  } as Record<string, string>,
  responsePlaceholder: 'Type your response...',
  selectPlaceholder: 'Select an option',
  submit: 'Submit Feedback',
  submitting: 'Submitting...',
  missingRequired: (fields: string) => `Please fill in: ${fields}`,
  subscriptionExtendedToast: 'Your subscription has been extended by 1 month!',
  thanksToast: 'Thank you for your feedback!',
  submitFailed: 'Failed to submit feedback',
  thankYou: 'Thank you!',
  submittedExtended:
    'Your feedback has been submitted and your subscription has been extended by 1 month!',
  submitted: 'Your feedback has been submitted successfully. We appreciate your input.',
  submitAnother: 'Submit another response',
};

export type FeedbackDict = typeof feedback;
